/**
 * begin Group
 * @param fb : FormBuilder
 */
export function beginGroup (fb: any):any {
    return fb.group({
        min: [''],
        max: ['']
    });
}
